import { StorageHelper } from "./storageHelper";
import { refreshToken } from "../services/apolloService";

const withAuthHeader = (options, token) => ({
  ...options,
  headers: {
    ...(options.headers || {}),
    Authorization: token ? `Bearer ${token}` : "",
  },
});

/**
 * fetch() wrapper for the authenticated chat proxy.
 *
 * Attaches the bearer token from storage. On a 401 it refreshes the token
 * (reusing the same refresh path as Apollo) and retries the request once with
 * the new token. The returned Response keeps its streaming body intact.
 *
 * @param {string} url
 * @param {RequestInit} [options]
 * @returns {Promise<Response>}
 */
export const authStreamFetch = async (url, options = {}) => {
  const token = StorageHelper.get("token");
  let response = await fetch(url, withAuthHeader(options, token));

  if (response.status === 401) {
    // refreshToken() is globally coalesced (shared with Apollo's errorLink) so a
    // simultaneous 401 on a GraphQL op and the chat stream triggers only one
    // Keycloak refresh. It redirects to /login if the refresh itself fails.
    const newToken = await refreshToken();
    if (newToken) {
      response = await fetch(url, withAuthHeader(options, newToken));
    }
  }

  return response;
};
